import type { Insurer } from '../../enums'
import type { PartPackage } from './PartPackage'


export interface AdditionBase {
    offerPartId?: number
    packageItemId?: number
    riskId?: number
    insurer?: Insurer
    limit?: string
    variantId?: number | null
    key?: string
    value?: any
}

export interface AdditionBicycle extends AdditionBase {
    color?: string
    type?: string
    bikeType: keyof typeof BikeKinds
    identification?: string
    brand?: string
    description?: string
    version?: string
}

export const BikeKinds = {
    Bike: 'Kolo',
    ElectricBike: 'Elektrokolo',
    Scooter: 'Koloběžka',
    ElectricScooter: 'Elektrokoloběžka',
    BikeTrailer: 'Připojný vozík na kolo'
} as const

export type BikeKinds = typeof BikeKinds[keyof typeof BikeKinds]

export interface AdditionPet extends AdditionBase {
    type: keyof typeof PetKinds
    age?: number | null
    chipId?: string
    name?: string
    race?: string
}

export const PetKinds = {
    Dog: 'Pes',
    Cat: 'Kočka'
} as const

export type PetKinds = typeof PetKinds[keyof typeof PetKinds]
export interface AdditionMedical extends AdditionBase {
    type?: string
    description?: string
}

export interface AdditionCycleAssistance extends AdditionBase {
    description: string
}

export interface AdditionIntLimitBase extends AdditionBase {
    key: string
}

export interface AdditionConstructionAssembly extends AdditionIntLimitBase {
    duration: DurationKinds
}

export interface AdditionSportEquipment extends AdditionBase {
    type?: string
    description?: string
}

export interface AdditionSportEquipmentTravel extends AdditionBase {
    description: string
}

export interface AdditionVehicle extends AdditionBase {
    registrationMark: string
}

export interface AdditionPetTravel extends AdditionBase {
    chipId: string
}

export const DurationKinds = {
    OneYear: '1 rok',
    TwoYears: '2 roky',
    ThreeYears: '3 roky'
} as const

export type DurationKinds = typeof DurationKinds[keyof typeof DurationKinds]

export interface AdditionMusicalInstrument extends AdditionBase {
    description: string
}

export interface OfferPropertyAddition extends OfferPackageAddition {
    bicycles: AdditionBicycle[]
    pets: AdditionPet[]
    medicals: AdditionMedical[]
    cycleAssistance: AdditionCycleAssistance[]
    constructionAssemblies: AdditionConstructionAssembly[]
    musicalInstruments: AdditionMusicalInstrument[]
    sportEquipments: AdditionSportEquipment[]
}

export interface OfferTravelAddition extends OfferPackageAddition {
    sportEquipments: AdditionSportEquipmentTravel[]
    vehicles: AdditionVehicle[]
    pets: AdditionPetTravel[]
}

export interface OfferPackageAddition {
    changedParts: { [x: number]: PartPackage }
    changedPackages: { [x: number]: { groupId?: number, packageId?: number } }
}